import { Component, EventEmitter, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FileErrorMessages } from 'app/components/merchant/partners-portal/enums/file-error-messages.enum';
import {
  BYTES,
  DECIMAL,
  FIVE_MEGABYTES,
  FRACTION_DIGITS,
  VALID_FILE_TYPES,
} from 'app/components/merchant/partners-portal/validators/file-upload.validator';
import { CommerceService } from 'app/services/commerce.service';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'add-availed-product-details',
  standalone: false,
  templateUrl: './add-availed-product-details.component.html',
  styleUrl: './add-availed-product-details.component.scss'
})
export class AddAvailedProductDetailsComponent implements OnInit {

  @Output() public isProductDetailsNotValid = new EventEmitter<boolean>();

  constructor(
    private commerceService: CommerceService,
    private messageService: MessageService
  ){}

  public products: any[] = [];
  public payment: string = '';

  public selectedProduct: any;

  public imageUrl: string[] = [];
  public files: File[] = [];
  fileErrorMessage: any[] = [];
  uploadInProgress: boolean = false;
  public productDetailsModel: any = {
    selectedProduct: {},
    payment: 1,
    imageUrl: [],
    files: [],
    serialNumber: ''
  };
  public loading: boolean = false;

  ngOnInit(): void {
    if(this.commerceService.productDetailModel ){
      this.productDetailsModel = this.commerceService.productDetailModel;
    }
    this.getProductFiltered();
  }

  getProductFiltered(){
    const dto = {
      SearchName: '',
      Skip: 0,
      Take: 10
    };

    this.commerceService.getProductFiltered(dto, this.messageService)
      .then(data => {
          if (!data.Success) {
              this.loading = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
              return;
          }
          this.products = data.Items;
          this.loading = false;
      })
      .catch(err => {
          this.loading = false;
          throw err;
      });
  }

  public handleImageChange(event: any) {
    this.uploadInProgress = true;
    const fileList = event.target ? event.target.files : event as HTMLInputElement;

    if (fileList) {
      this.productDetailsModel.files = Array.from(fileList);
    }

    if (!this.productDetailsModel.files) {
        return;
    }

    if(this.productDetailsModel.files.length > 6){
      this.fileErrorMessage = [{
        severity: 'error', detail: 'You can upload up to 6 images of the product. ' +
      'Don\'t forget to include photos that show the serial number or any unique identifiers.'
      }];
      this.productDetailsModel.imageUrl = [];
      this.productDetailsModel.files = [];

      return;
    }

    for(const file of this.productDetailsModel.files){
      const fileIsValid = this.fileValidator(file as File);

      if (!fileIsValid) {
        return;
      }

      const reader = new FileReader();
      reader.onload = (e) => {
        if (e?.target?.result) {
            // Base64 string
            this.productDetailsModel.imageUrl.push(e.target.result.toString());
            this.commerceService.productDetailModel = this.productDetailsModel;
            this.isProductDetailsNotValid.emit(this.productDetailsModel.imageUrl.length === 0
              || !this.productDetailsModel.selectedProduct
              || !this.productDetailsModel.payment);
        }
      };

      reader.readAsDataURL(file);
    }

    this.uploadInProgress = false;
  }

  fileValidator(file: File): boolean {
    const filesize = parseInt(
      (file.size / BYTES / BYTES).toFixed(FRACTION_DIGITS),
      DECIMAL
    );

    const fileTypeIsValid = VALID_FILE_TYPES.includes(file.type);
    if (!fileTypeIsValid) {
      this.fileErrorMessage = [{
        severity: 'error', detail: FileErrorMessages.INVALID_FILE_FORMAT
      }];
      this.productDetailsModel.imageUrl = [];
      this.productDetailsModel.files = [];

      return false;
    }

    if (filesize > FIVE_MEGABYTES) {
      this.fileErrorMessage = [{
        severity: 'error', detail: FileErrorMessages.IMAGE_SIZE_EXCEEDED
      }];
      this.productDetailsModel.imageUrl = [];
      this.productDetailsModel.files = [];

      return false;
    }
    return true;
  }

  removeImages(index?: number){
    if(index !== undefined){
      this.productDetailsModel.imageUrl.splice(index, 1);
      this.productDetailsModel.files.splice(index, 1);
    } else {
      this.productDetailsModel.imageUrl = [];
      this.productDetailsModel.files = [];
    }
    this.commerceService.productDetailModel = this.productDetailsModel;
    this.isProductDetailsNotValid.emit(this.productDetailsModel.imageUrl.length === 0 || !this.productDetailsModel.selectedProduct || !this.productDetailsModel.payment);
  }

  productChanged(){
    this.commerceService.productDetailModel = this.productDetailsModel;
    this.isProductDetailsNotValid.emit(this.productDetailsModel.imageUrl.length === 0 || !this.productDetailsModel.selectedProduct || !this.productDetailsModel.payment);
  }

  paymentChanged(){
    this.commerceService.productDetailModel = this.productDetailsModel;
    this.isProductDetailsNotValid.emit(this.productDetailsModel.imageUrl.length === 0 || !this.productDetailsModel.selectedProduct || !this.productDetailsModel.payment);
  }

  serialNumberChanged(){
    this.commerceService.productDetailModel = this.productDetailsModel;
  }
}
